import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function LegalPage({ title, lastUpdate = "21 avril 2026", sections = [], testid }) {
  return (
    <div className="min-h-screen bg-[#FFFBF5] flex flex-col" data-testid={testid}>
      <Navbar />
      <main className="flex-1 max-w-[820px] mx-auto px-6 sm:px-10 lg:px-0 py-20 w-full">
        <Link to="/" className="caption-label text-[#A26F3E] hover:text-[#1A1A1A] transition">
          ← Retour à l'accueil
        </Link>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#1A1A1A] mt-4 leading-tight">
          {title}
        </h1>
        <p className="text-xs tracking-widest uppercase text-[#8C7D6B] mt-3">
          Dernière mise à jour · {lastUpdate}
        </p>
        <div className="h-px bg-[#EADDC9] my-10" />
        <div className="space-y-10">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-serif text-2xl text-[#1A1A1A] mb-3">{s.heading}</h2>
              <div className="space-y-3 text-[15px] leading-relaxed text-[#3C2C1D]">
                {s.body.map((p, j) =>
                  typeof p === "string" ? (
                    <p key={j}>{p}</p>
                  ) : (
                    <ul key={j} className="list-disc pl-5 space-y-1.5">
                      {p.map((li, k) => <li key={k}>{li}</li>)}
                    </ul>
                  )
                )}
              </div>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
